"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logout = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var logout_1 = require("../../model/logout");
var service_1 = require("../../../library/base/service");
var Logout = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Logout, _super);
    function Logout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '账号登出接口';
        _this.code = '101080';
        _this.desc = '账号登出接口';
        _this.requestParams = new logout_1.LogoutRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Logout;
}(service_1.BaseService));
exports.Logout = Logout;
//# sourceMappingURL=logout.js.map